var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.258 0 24 10.742 24 24S37.258 48 24 48 0 37.258 0 24 10.742 0 24 0zm0 3.79C12.835 3.79 3.79 12.834 3.79 24c0 11.165 9.045 20.21 20.21 20.21 11.165 0 20.21-9.045 20.21-20.21 0-11.165-9.045-20.21-20.21-20.21zm3.912 25.426c3.496 0 6.495 1.988 8.027 4.873-2.869 3.39-7.155 5.558-11.939 5.558s-9.07-2.168-11.939-5.558c1.532-2.885 4.531-4.873 8.027-4.873.196 0 .391.032.579.09 1.06.342 2.168.562 3.333.562s2.282-.22 3.333-.563c.188-.057.383-.09.579-.09zM24 11.613a7.172 7.172 0 1 1 0 14.343 7.172 7.172 0 0 1 0-14.343z"
  }))));
};
export default SvgSettings;